import {
    getSetupIntent,
    listSetupIntents
} from './queries';
import {
    createSetupIntent,
    deleteSetupIntent,
    updateSetupIntent,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateSetupIntent,
    DeleteSetupIntent,
    GetSetupIntent,
    ListSetupIntents,
    SetupIntent,
    UpdateSetupIntent
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (filter: object, limit?: number, nextToken?: string) => {

    const response = await client.graphql<GraphQLQuery<ListSetupIntents>>({
                                                                                query: listSetupIntents,
                                                                                variables: {filter: filter, limit, nextToken},
                                                                            });
    return response.data?.listSetupIntents;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetSetupIntent>>({
                                                                              query: getSetupIntent,
                                                                              variables: {id: id},
                                                                          });
    return response.data?.getSetupIntent;
};

export const add = async (payload: object) => {

    const response = await client.graphql<GraphQLQuery<CreateSetupIntent>>({
                                                                                 query: createSetupIntent,
                                                                                 variables: {input: payload},
                                                                             });

    return response.data?.createSetupIntent;
};

export const update = async (_id: string, record: SetupIntent) => {

    const payload = {...record} as Record<string, unknown>;
    delete payload.created;
    delete payload.clientSecret;
    delete payload.lastSetupError;
    delete payload.paymentMethodTypes;
    delete payload.status;
    delete payload.usage;

    const response = await client.graphql<GraphQLQuery<UpdateSetupIntent>>({
                                                                                 query: (updateSetupIntent),
                                                                                 variables: {input: payload},
                                                                             });
    return response.data?.updateSetupIntent;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteSetupIntent>>({
                                                                                 query: (deleteSetupIntent),
                                                                                 variables: {input: {id: id}},

                                                                             });
    return response.data?.deleteSetupIntent;
};
